export const getFileByUUID = async (endpoint, index) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/${endpoint}?index=${index}&output=url`

        const response = await fetch(url, {
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
        })

        if (!response.ok) {
            throw new Error(
                `Failed to fetch file: ${response.status} ${response.statusText}`,
            )
        }
        const data = await response.json()

        return data.url
    } catch (err) {
        console.error('An error occurred while fetching the file:', err)
        throw err
    }
}